import React from 'react';
import { Typography } from '@duxton-web/ui';

import { colorBackgroundAltInverse } from '@duxton-web/design-tokens/themes/light';

// Customize the required mark for the form fields in duxton to be a red asterisk after the label
const CustomizeRequiredMark = (label, { required }) => (
  <React.Fragment>
    <Typography.Body level={2} style={{ color: colorBackgroundAltInverse }}>
      {label}
    </Typography.Body>
    {required && (
      <Typography.Body level={2} style={{ color: 'red', marginLeft: 5 }}>
        *
      </Typography.Body>
    )}
  </React.Fragment>
);

export default CustomizeRequiredMark;
